define('models/LanguageCollection',['underscore','ObjectCollection','LocalStorage','models/LanguageModel','site_vars'],
    function (_,ObjectCollection,LocalStorage,LanguageModel,site_vars) {
    //
    // Collection Language
    //
    var LanguageCollectionPrototype = {
        
        name:'LanguageCollection',
        route:'apiLanguageCollection',
        model:LanguageModel,
        initialize:function(){
            // ObjectCollection constructor heritage
            var collection = this;
            ObjectCollection.prototype.initialize.apply(collection,arguments);
            //
            collection.on('sync',collection.onSync,collection);
            //
        },
        getDefault:function(){
            return this.findWhere({default_lang:true});
        }
    };

    var LanguageCollection = ObjectCollection.extend(LocalStorage).extend(LanguageCollectionPrototype);

    return LanguageCollection;
});
